import { format, parseISO } from 'date-fns'
import _ from 'lodash'

export function dateToGoogle(dateTime) {
  if (!dateTime) return

  if (_.isDate(dateTime)) {
    dateTime = dateTime.toISOString()
  }

  let [date] = dateTime.split('T')
  date = date.split('-')

  return {
    year: date[0],
    month: date[1],
    day: date[2],
  }
}

export function timeToGoogleAPI(dateTime) {
  if (!dateTime) return

  if (_.isDate(dateTime)) {
    dateTime = dateTime.toISOString()
  }

  let [, time] = dateTime.split('T')
  time = time.split(':')

  return {
    hours: time[0],
    minutes: time[1],
    seconds: 0,
    nanos: 0,
  }
}

export function timeToGoogle(dateTime) {
  if (!dateTime) return

  if (_.isString(dateTime)) {
    dateTime = new Date(dateTime)
  }

  return format(dateTime, 'HH:mm')
}

export function formatISO(iso) {
  if (!iso) return
  return format(parseISO(iso), 'MM/dd/yyyy HH:mm')
}
